import { Chip } from '@mui/material';
import { useMemo } from 'react';
import { UserType } from '../../core/enums/userType.enum';

interface Props {
  role: UserType;
}

function CompanyRoleChip(props: Props) {
  const { role } = props;

  const color = useMemo(() => {
    if (role === UserType.admin) return 'warning';
    if (role === UserType.user) return 'info';
  }, [role]);

  const label = useMemo(() => {
    if (role === UserType.admin) return 'Admin';
    if (role === UserType.user) return 'Usuario';
  }, [role]);

  return (
    <Chip color={color}  label={label}  size="small"  />
  );
}

export default CompanyRoleChip;
